import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "ramda";
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
} from "react-intl";
import Main from "common/mdc/layout";
import QuickSearch from "common/components/search";
import Button from "common/mdc/button";
import { Primary } from "common/mdc/layout";
import DateTime from "common/components/dateTime";
import Table, {
  TableRow,
  TableCell,
  TableActionCell,
  TableHead,
} from "common/mdc/table";
import CollectionWrapper from "common/mdc/wrappers/collection";
import { selectors, actions } from "@sma/store/tag/tags";
import TagPill from "../components/tag/TagPill";
import Menu, { MenuItem } from "common/mdc/menu";
import { Link } from 'found';
import WithDialog from "common/mdc/dialog/withDialog";
import CreateNewTag from "../components/tag/create/createNewTag";
import Dialog, { withConfirmationDialog } from "common/mdc/dialog";
import { actions as deviceSearchActions } from '@sma/store/device/search';
import { actions as deviceActions } from "@sma/store/device/devices";
import Pagination from 'common/mdc/table/pagination';

const messages = defineMessages({
  title: {
    id: 'title.tags',
    defaultMessage: 'Tags',
  },
  tagsSummary: {
    id: "tags.pagination.summary",
    defaultMessage:
      "{count, number} {count, plural, one {tag} other {tags}} of {total} displayed",
  },
  noTags: {
    id: "tags.noTags",
    defaultMessage: "No tags found",
  },
  tagsLoading: {
    id: "tags.tagsLoading",
    defaultMessage: "Tags loading",
  },
  tagsPerPage: {
    id: "tags.tagsPerPage",
    defaultMessage: "Tags per page",
  },
  deleteTag: {
    id: 'tags.deleteTag',
    defaultMessage: 'Are you sure, you want to delete?',
  },
  tagsPerPage: {
    id: 'tags.tagsPerPage',
    defaultMessage: 'Tags per page',
  },
  deleteAttachedTag: {
    id: 'tags.deleteAttachedTag',
    defaultMessage: 'This tag is currently associated with {tagsAttachedToMeterCount} no. of meter(s). Deleting it, may impact meter configurations or reports. Do you still want to proceed?',
  },
});

class Tags extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleCreateTag = this.handleCreateTag.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handelSearchLoad = this.handelSearchLoad.bind(this);
    this.handleEditTag = this.handleEditTag.bind(this);
    this.handleDeleteTag = this.handleDeleteTag.bind(this);
    this.handleTagFilter = this.handleTagFilter.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);

    this.state = {
      tagInfo: {
        id: undefined,
        label: undefined,
        namespace: undefined,
        description: undefined,
      },
      searchText: "",
      isEdit: false,
      limit: 10,
      offset: 0,
    };
  }

  handleCreateTag() {
    this.setState(
      {
        isEdit: false,
        tagInfo: {
          id: undefined,
          label: undefined,
          namespace: undefined,
          description: undefined,
        },
      },
      () => {
        this.props.showCreateTagDialog(true);
      }
    );
  }

  handleEditTag(obj) {
    this.setState({
      isEdit: true,
      tagInfo: {
        id: obj.id,
        label: obj.label,
        namespace: obj.namespace,
        description: obj.description
      }
    }, ()=>{
      this.props.showCreateTagDialog(true);
    })
  }

  handleDeleteTag(id){
    const {searchText, offset, limit} = this.state;
    const { pageNumber } = this.props;
    const searchTagPageNumber = (offset/limit+1);
    this.props.deleteTagById(id, pageNumber, [], searchText, searchTagPageNumber, limit);
  }

  handleSearch(e){
    this.setState({
      searchText: e.target.value,
      offset: 0,
    }, ()=>{
      const {searchText, limit} = this.state;
      if(searchText.length >= 3){
        this.props.searchTagsByLabel(
          {search: searchText, page: 1, limit},
          1,
          []
        );
        return;
      }
      if(searchText.length === 0){
        this.props.load(1, [], false, limit);
      }
    });
  }

  handelSearchLoad() {
    this.props.searchTagsByLabel(
      {search: this.state.searchText, page: this.props.searchTagPageNumber + 1},
      this.props.searchTagPageNumber + 1,
      this.props.data
    );
  }

  clearSearch(){
    this.setState({
      searchText: ""
    })
  }

  handleTagFilter(namespace, label, tagId){
    this.props.advancedToggleExpanded ? null : this.props.toggleAdvancedSearch();
    this.props.clearCriteria();
    this.props.addCriteria({
      property: "tagId",
      nullable: true,
      type: "plain",
      label:{
        key: null,
        ref: null,
        props: {
          id: "meter.search.advanced.tags",
          defaultMessage: "Tags"
        }
      }
    });
    this.props.devicesFilterByTag(`${namespace}:${label}`);
    this.props.setValue({
      nullable: true,
      property: "tagId",
      type: "plain",
      constraints:[{operator: "=", value: tagId}],
    }, 0, tagId);
    this.props.applyCriteria({
      nullable: true,
      property: "tagId",
      type: "plain",
    });
  }

  handlePageChange({limit, offset}){
    const { searchText } = this.state;
    this.setState({limit, offset},()=>{
      const pageNum = offset === 0 ? 1 : (offset/limit+1);
      searchText.length >= 3 ?
        this.props.searchTagsByLabel({search: searchText, page: pageNum, limit}, 1, []) :
        this.props.load(pageNum, [], false, limit);
    });
  }

  render() {
    const {
      tagsContext,
      loading,
      data,
      total,
      showDialog,
      deleteDialogPopup,
    } = this.props;

    const {
      searchText,
      tagInfo,
      isEdit,
      limit,
      offset
    } = this.state;

    const handleCreateCallback = () => {
      this.setState({ offset: 0 });
    }

    return (
      <Main
        title={<FormattedMessage {...messages.title} />}
        tools={
          <QuickSearch
            placeholder={"Search for labels (minimum 3 characters)"}
            value={searchText}
            onChange={(e)=>this.handleSearch(e)}
          />
        }
      >
        <Primary loading={loading}>
          <CollectionWrapper
            loading={loading}
            context={tagsContext}
            pagination={
              <Pagination
                onChange={this.handlePageChange}
                itemsPerPage={messages.tagsPerPage}
                limit = {limit}
                offset = {offset}
                total = {total}
              />
            }
            tools={() => <Button  onClick={() => this.handleCreateTag()}>create tag</Button>}
            messages={{
              loading: <FormattedMessage {...messages.tagsLoading} />,
              empty: <FormattedMessage {...messages.noTags} />,
              summary: (count) => (
                <FormattedMessage
                  values={{ count, total }}
                  {...messages.tagsSummary}
                />
              ),
            }}
          >
            <Table className="meters-table">
              <TableHead>
                <TableCell
                  title={"ID"}
                  style={{
                    minWidth: "180px",
                  }}
                >
                  ID
                </TableCell>
                <TableCell title={"Tag"}>Tag</TableCell>
                <TableCell title={"Description"}>Description</TableCell>
                <TableCell title={"Created at"} alignRight>
                  Created at
                </TableCell>
                <TableCell title={"Updated at"} alignRight>
                  Updated at
                </TableCell>
                <TableCell actions title={"Actions"}>
                  Actions
                </TableCell>
              </TableHead>
              {data
                ? data.map((obj) => (
                    <TableRow key={obj.tagId}>
                      <TableCell style={{ direction: "rtl" }} title={obj.tagId}>
                        {obj.tagId}
                      </TableCell>
                      <TableCell title={`${obj.namespace} -- ${obj.label}`}>
                        <Link
                          to={`/devices`} style={{ textDecoration: "none" }}
                          onClick={()=>this.handleTagFilter(obj.namespace, obj.label, obj.tagId)}
                        >
                          <TagPill
                            nameSpace={obj.namespace}
                            label={obj.label}
                            isDeleted={obj.isDeleted}
                          />
                        </Link>
                      </TableCell>
                      <TableCell title={obj.description}>
                        <span>{obj.description}</span>
                      </TableCell>
                      <TableCell>
                        <DateTime value={obj.created} seconds />
                      </TableCell>
                      <TableCell>
                        <DateTime value={obj.updated} seconds />
                      </TableCell>
                      <TableActionCell>
                        <Menu>
                          <MenuItem onClick={() => this.handleEditTag({id: obj.tagId, label: obj.label, namespace: obj.namespace, description: obj.description,})}>
                            Edit
                          </MenuItem>
                          <MenuItem onClick={() => deleteDialogPopup({
                            resolve: () => {this.handleDeleteTag(obj.tagId)},
                            tagsAttachedToMeterCount: obj.activeMetersCount
                          })}>
                            Delete
                          </MenuItem>
                        </Menu>
                      </TableActionCell>
                    </TableRow>
                  ))
                : null}
            </Table>
          </CollectionWrapper>
        </Primary>
        {showDialog ? <CreateNewTag tagInfo={tagInfo} clearSearch={()=>this.clearSearch()} handleCreateCallback={()=>handleCreateCallback()} isEdit={isEdit} isFromSearch={searchText.length > 0} limit={limit}/> : null}
      </Main>
    );
  }
}

const DeleteDialogPopup = ({ buttons, onClose, tagsAttachedToMeterCount }) => (
  <Dialog
    title={"Delete Tag?"}
    buttons={buttons}
    onClose={onClose}
  >
    {
      tagsAttachedToMeterCount > 0 ?
      <FormattedMessage
        values={{ tagsAttachedToMeterCount }}
        {...messages.deleteAttachedTag}
      /> :
      <FormattedMessage {...messages.deleteTag} />
    }
  </Dialog>
);

DeleteDialogPopup.propTypes = {};

export default compose(
  connect(
    (state) => {
      return {
        tagsContext: selectors.getTagsContext(state),
        loading: selectors.isLoading(state),
        data: state.tags.data,
        total: state.tags.total,
        pageNumber: state.tags.pageNumber,
        showDialog: state.tags.createTag.showDialog,
        searchTagPageNumber: state.tags.searchTagPageNumber,
        advancedToggleExpanded: state.device.search.expanded,
      };
    },
    {
      load: actions.load,
      showCreateTagDialog: actions.showCreateTagDialog,
      searchTagsByLabel: actions.searchTagsByLabel,
      deleteTagById: actions.deleteTag,
      toggleAdvancedSearch: deviceSearchActions.toggleExpand,
      addCriteria: deviceSearchActions.addCriteria,
      devicesFilterByTag: deviceActions.devicesFilterByTag,
      setValue: deviceSearchActions.setValue,
      clearCriteria: deviceSearchActions.clear,
      applyCriteria: deviceSearchActions.applyCriteria,
    }
  ),
  WithDialog(CreateNewTag, 'createNewTag'),
  injectIntl,
  withConfirmationDialog(DeleteDialogPopup, 'deleteDialogPopup'),
)(Tags);
